import * as Sentry from '@sentry/vue';

import type { App } from 'vue';
import type { Router } from 'vue-router';

export default function registerSentry(app: App, router: Router): void {
  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN as string,
    environment: process.env.VUE_APP_SENTRY_ENVIRONMENT as string,
    release: process.env.VUE_APP_SENTRY_RELEASE as string,

    initialScope: {
      tags: {
        platform: 'educator',
        language: 'vue',
      },
    },

    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],

    tracePropagationTargets: [
      'localhost',
      (process.env.VUE_APP_API_URL as string)?.replace(/^https?:\/\//, '') ?? '',
    ],

    // Performance monitoring sample rate (0.0-1.0)
    tracesSampleRate: parseFloat(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE || '0'),
  });
}
